module.exports = __webpack_public_path__ + "static/media/close-circle-filled.da0a3685.svg";